import { GDFPalletCode } from '../../../gdf/type';
import { getPalette } from '../../../palettes/palettes';
import { generateColorExpressionFromPalette } from '../../../utils/ramp';
import { StyleFactory } from '../styling';

export const lightningProbabilityLayers: StyleFactory = (baseId, settings) => {
    const palette = getPalette(GDFPalletCode.lightning_prb, settings);
    if (!palette) {
        return [];
    }

    const colorExpression = generateColorExpressionFromPalette(palette, ['get', 'id']);

    return [
        {
            id: baseId + '-fill',
            source: baseId,
            type: 'fill',
            paint: {
                'fill-color': colorExpression,
                'fill-opacity': ['global-state', 'polygon-transparency']
            }
        },
        {
            id: baseId + '-line',
            source: baseId,
            type: 'line',
            paint: {
                'line-color': colorExpression
            }
        }
    ];
};

export const lightningJumpGridLayers: StyleFactory = (baseId, settings) => {
    const palette = getPalette(GDFPalletCode.lightning_jumpgrid, settings);
    if (!palette) {
        return [];
    }

    const colorExpression = generateColorExpressionFromPalette(palette, ['get', 'id']);

    return [
        {
            id: baseId + '-fill',
            source: baseId,
            type: 'fill',
            paint: {
                'fill-color': colorExpression,
                'fill-opacity': ['global-state', 'polygon-transparency']
            }
        },
        {
            id: baseId + '-line',
            source: baseId,
            type: 'line',
            paint: {
                'line-color': colorExpression
            }
        }
    ];
};
